import React, {useState} from 'react';
import 'contents/assets/scss/page/mypage.scss';
import Paging from '../../component/Inc/Paging';
import Tab from '../../component/Inc/Tab';
import Upload from '../../component/Inc/Upload';
function CertificateRequest() {
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '원천징수 영수증', value: 0},
    {title: '재직증명서', value: 1},
    {title: '보험증명서', value: 2},
    {title: '내 요청 목록', value: 3}
  ];
  return (
    <main className="com_container p_manage_certificate">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu12_10">증명서 요청</h2>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
              <section className="com_board_search end">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="10%" />
                <col width="20%" />
                <col width="30%" />
                <col width="10%" />
                <col width="10%" />
              </colgroup>
              <thead>
                <tr>
                  <th>요청일</th>
                  <th>내용</th>
                  <th>요청 증명서</th>
                  <th>요청자</th>
                  <th>비고</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>2022.08.25</td>
                  <td>이거 말고 다른 증명서가 필요합니다.</td>
                  <td>
                    <div className="com_btn_wrap certificate_wrap">
                      <span className="com_btn line orange xs">원천징수 영수증</span>
                      <span className="com_btn line orange xs">재직증명서</span>
                    </div>
                  </td>
                  <td>홍길동103</td>
                  <td className="td_point">답변 대기</td>
                </tr>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>2022.08.25</td>
                      <td>이거 말고 다른 증명서가 필요합니다.</td>
                      <td>
                        <div className="com_btn_wrap certificate_wrap">
                          <span className="com_btn line orange xs">원천징수 영수증</span>
                          <span className="com_btn line orange xs">재직증명서</span>
                          <span className="com_btn line orange xs">보험증명서</span>
                        </div>
                      </td>
                      <td>홍길동103</td>
                      <td>
                        관리자 <br />
                        2022,09,25
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Paging />
          </section>
          {/* 상세보기 */}
          <section className="box">
            <div className="detail_tit dot">상세보기</div>
            <div className="com_info">
              <p className="name">홍길동104</p>
              <span className="dot" />
              <p className="date">2023.05.20 11:30</p>
              <div className="count">
                <p>
                  댓글 <span className="cnt">10</span>
                </p>
                <span className="dot" />
                <p>
                  조회 <span className="cnt">321</span>
                </p>
              </div>
            </div>
            <div className="com_input_wrap">
              <textarea className="textarea" placeholder="증명서 발급 요청 드립니다."></textarea>
            </div>
            <div className="detail_tit_sub">
              <p className="name">요청서류</p>
            </div>
            <div className="certificate_wrap w_auto">
              <span className="com_btn orange xs line">원천징수 영수증</span>
              <span className="com_btn orange xs line">재직증명서</span>
              <span className="com_btn orange xs line">보험증명서</span>
              <span className="com_btn orange xs line">사업자 등록증</span>
            </div>
            <div className="detail_tit_sub">
              <p className="name">수령방법 : 팩스</p>
            </div>
            <div className="com_input_wrap">
              <input type="text" className="input" />
            </div>
            <div className="detail_tit_sub">
              <p className="name">요청서 보내기</p>
            </div>
            <div className="com_input_wrap">
              <textarea className="textarea" placeholder="내용 입력"></textarea>
            </div>
            <div className="com_input_upload">
              <Upload title="파일 등록" className="com_btn gray s wl" />
              <p className="file">
                <span className="txt">File name.pdf</span>
                <button type="button" className="btn_del_file" onClick={() => {}}></button>
                <button type="button" className="btn_down" onClick={() => {}}></button>
              </p>
            </div>
            <hr className="com_divider" />
            <div className="com_btn_wrap center bottom">
              <div className="com_btn orange xs wl">보내기</div>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
}

export default CertificateRequest;
